import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:5001/api",
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

// CSRF token issued by the backend at login (also returned by /admin-panel/me).
// Sent on every request; the backend validates it for state-changing methods.
let csrfToken = null;

api.interceptors.request.use((config) => {
  if (csrfToken) {
    config.headers["X-CSRF-Token"] = csrfToken;
  }
  return config;
});

api.interceptors.response.use(
  (res) => {
    if (res.data?.csrf_token) {
      csrfToken = res.data.csrf_token;
    }
    return res;
  },
  (err) => {
    if (err.response?.status === 401) {
      window.dispatchEvent(new Event("unauthorized"));
    }
    return Promise.reject(err);
  }
);

export default api;

// ── Auth ──
export const adminLogin = (data) => api.post("/admin-panel/login", data);
export const adminLogout = () => api.post("/admin-panel/logout");
export const adminMe = () => api.get("/admin-panel/me");

// ── Admin accounts (superadmin only) ──
export const getAdmins = () => api.get("/admin-panel/admins");
export const createAdmin = (data) => api.post("/admin-panel/admins/create", data);
export const toggleAdmin = (id) => api.put(`/admin-panel/admins/${id}/toggle`);
export const changeAdminRole = (id, role) => api.put(`/admin-panel/admins/${id}/role`, { role });

// ── Stats ──
export const getStats = () => api.get("/admin-panel/stats");

// ── Users ──
export const getUsers = (params) => api.get("/admin-panel/users", { params });
export const toggleUser = (id) => api.put(`/admin-panel/users/${id}/toggle`);
export const verifyUserEmail = (id) => api.put(`/admin-panel/users/${id}/verify-email`);

// ── Jobs ──
export const getJobs = (params) => api.get("/admin-panel/jobs", { params });
export const toggleJob = (id) => api.put(`/admin-panel/jobs/${id}/toggle`);

// ── Waitlist ──
export const getWaitlist = () => api.get("/admin-panel/waitlist");
export const exportWaitlist = () => api.get("/admin-panel/waitlist/export", { responseType: "blob" });
export const sendWaitlistEmail = (data) => api.post("/admin-panel/waitlist/email", data);

// ── Passcodes ──
export const listPasscodes    = ()    => api.get("/admin-panel/passcode/list");
export const generatePasscode = ()    => api.post("/admin-panel/passcode/generate");
export const revokePasscode   = (id) => api.delete(`/admin-panel/passcode/${id}`);
